import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import { TextareaInlineField } from '../../../../Textarea'
import {
  FLAT_FORM_FIELD_NAME_NOTES,
  FLAT_FORM_NOTES_FIELD_MAX_LENGTH,
} from '../../FlatForm.constants'

import { NOTES_FIELD_MIN_ROWS } from './NotesField.constants'

function NotesField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      clearable
      hasCounter
      Component={TextareaInlineField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        info: t('Flat.NotesInfoKey'),
        label: `${t('Flat.NotesLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      maxLength={FLAT_FORM_NOTES_FIELD_MAX_LENGTH}
      minRows={NOTES_FIELD_MIN_ROWS}
      name={FLAT_FORM_FIELD_NAME_NOTES}
      placeholder={t('Flat.NotesPlaceholderKey')}
    />
  )
}

export default NotesField
